export default class SelectedGrantee {
  constructor(id, title, type, capabilityId) {
    this._value = { id, title, type, capabilityId };
  }
  get id() {
    return this._value.id;
  }
  get title() {
    return this._value.title;
  }
  get type() {
    return this._value.type;
  }
  get capabilityId() {
    return this._value.capabilityId;
  }
  currentState(activeShares) {
    const { capabilityId, id } = this._value;
    const activeShare = activeShares.find((share) => share.grantee === id);
    if (!activeShare) return "new";
    if (activeShare.capability !== capabilityId) return "changed";
    return "unchanged";
  }
  static create(id, title, type, capabilityId) {
    return new SelectedGrantee(id, title, type, capabilityId);
  }
}
